import React, { PropTypes, Component } from 'react';
import { Link } from 'react-router';

import Header from '../../../../components/controls/header/Header.jsx';
import Image from '../../../controls/image/Image.jsx';
import {
    ICON_LOGOUT,
    ICON_ARROW_GRAY,
} from 'pluton-core/lib/constants/image.constant';

import { history } from '../../../../entry/history';
import ProgressBar from '../../../controls/progressBar/ProgressBar.jsx';


class UtilitySettingsPage extends Component {

    handleSubmit = () => {
    };

    handleOnBack = () => {
        history.goBack();
    };

    renderHeader = () => {
        return (
            <Header headerTitle='Utility setting'>
                <Link className="header__link header__link--left"
                      onClick={this.handleOnBack}>
                    <Image src={ICON_ARROW_GRAY}
                           className="header__icon header__icon--left"
                           imgClassName="icon icon--header"/>
                </Link>
            </Header>
        );
    };

    renderBody() {
        return (
            <div className="form">
            </div>
        );
    }

    renderProgressBar = () => {
        const { modelData } = this.props;
        if (!modelData.isLoading) {
            return null;
        }

        return (
            <ProgressBar/>
        );
    };

    renderSaveButton = () => {
        return (
            <div className="btn-wrap">
                <Link onClick={this.handleSubmit} className="btn btn--prime">
                    Save
                </Link>
            </div>
        );
    };

    render() {
        return (
            <div className="app-container">
                <div className="page">
                    {this.renderHeader()}
                    <div className="page__content page__content--settings">
                        {this.renderBody()}
                        {this.renderProgressBar()}
                        {this.renderSaveButton()}
                    </div>
                </div>
            </div>
        );
    }
}

UtilitySettingsPage.PropTypes = {
    model: PropTypes.func,
    error: PropTypes.object,
    loginModelData: PropTypes.object,
    handleSubmit: PropTypes.func,
};

export default UtilitySettingsPage;



// WEBPACK FOOTER //
// ./app/components/pages/service/utilitySettings/UtilitySettings.page.jsx